import { resizeText } from '@lib/resize-text';

window.Drupal.behaviors.textResize = {
    attach: function (context) {
        const elements = context.querySelectorAll('[data-text-resize]');
        if (!elements.length) return;

        elements.forEach((element) => setTimeout(() => {resizeText(element)}, 1000));

        window.addEventListener('resize', () => {
            elements.forEach(resizeText);
        });
    },
};
